import _ from 'underscore';
import template from '../template/campaign-bidlandscape.pug';
import { CampaignBidLandscapeViewModel } from './viewmodel';
import { BidLandscapeBaseView } from '../base-view';
import { BID_MODE, SYMBOL_PERCENT, STRING_MAP } from './bid-mode';
import highchartsConfig from '../highcharts-config';

export class CampaignBidLandscape extends BidLandscapeBaseView {
  initialize({
    parentItem = {},
    i18n,
    dataToShow = {},
    isForVNext,
  }) {
    super.initialize({
      parentItem,
      i18n,
      dataToShow,
      isForVNext,
    });

    this.viewModel.currentSelectedColomn.subscribe(() => {
      this.onSelectionUpdate();
    });

    this.viewModel.campaignSelectMode.subscribe(() => {
      this.trigger('selectModeChange');
    });
  }
  get ViewModel() {
    return CampaignBidLandscapeViewModel;
  }

  get template() {
    return () => template(_.extend(this.viewModel, {
      BID_MODE,
      SYMBOL_PERCENT,
      isForVNext: this.isForVNext,
      isCampaignLevel: true,
    }));
  }
  campaignSelectMode() {
    return this.viewModel.campaignSelectMode();
  }
  additionalBuget() {
    return this.viewModel.additionalBuget();
  }
  keepCurrentBudget() {
    return this.viewModel.keepCurrentBudget();
  }
  hash() {
    return this.viewModel.hash();
  }
  initBidLandscapeChartsOptions() {
    const options = highchartsConfig.getCampaignSlideChartOptions(
      this.viewModel.isClickGraph(),
      this.options.i18n,
      this.viewModel.currencySymbol()
    );
    super.initBidLandscapeChartsOptions(options);
  }
  prepareChartData() {
    if (!this.viewModel.hasData()) {
      this.viewModel.convertDataForBidLandscape();
    }
    const selectedCol = this.viewModel.currentSelectedColomn();
    const xAlixTitle = this.options.i18n.getString(STRING_MAP[selectedCol]);
    const yAxisTitle = this.options.i18n.getString(STRING_MAP.cost);
    this.slideChartOptions = super.prepareChartData(true, selectedCol, {
      name: xAlixTitle,
      bidName: this.options.i18n.getString('KPI_Campaign_Bid'),
      costName: yAxisTitle,
    });

    this.slideChartOptions.xAxis.title.text = xAlixTitle;
    this.slideChartOptions.title.text = yAxisTitle;
    this.slideChartOptions.yAxis.title.text = null;
    return this.slideChartOptions;
  }
}
